export default [
   {
    title: "Tags",
    customIcon: "TagsSvg",
    children: [
      {
        title: "Tags List",
        route: "custom-tags-list",
        path: "/custom-tags/list",
      },
    ],
  },
];